import {
    MediaType,
    // FeedPostDropDown,
    // PostMedia2,
    PostText,
    PostUserBlock,
    SocialCount
} from "ui";
import ThreadSubPost from "./ThreadSubPost";
import { CustomComponentProps, FeedPostObj } from "utils/types/general.types";
import { Link } from "react-router-dom";
// import { posts } from "assets/data/posts";

export type ThreadPostProps = CustomComponentProps & {
    post: FeedPostObj;
    threads: FeedPostObj[];
    showThreads?: boolean;
};

const ThreadPost = ({
    post,
    threads,
    showThreads = false
}: ThreadPostProps) => {
    return (
        <div className="card thread-post">
            <div className="card is-post relative">
                <Link
                    to={`/post/${post.id}`}
                    className="absolute float-link"
                    style={{ borderRadius: "0.75rem 0.75rem 0 0" }}
                ></Link>
                {/* <!-- Main wrap --> */}
                <div className={`content-wrap`}>
                    <div className="p-relative">
                        <div
                            className={`thread-post-v-line ${!showThreads ? "main-thread" : ""}`}
                        ></div>
                        {/* <!-- Post header --> */}
                        <div className="card-heading">
                            {/* <!-- User meta --> */}
                            <PostUserBlock user={post.user} time={post.time} />
                            {/* Right side dropdown */}
                            {/* <FeedPostDropDown /> */}
                        </div>
                        {/* <!-- /Post header --> */}

                        <div className="thread-post-body">
                            {/* <!-- Post body --> */}
                            <div className="card-body">
                                {/* <!-- Post body text --> */}
                                <PostText text={post.text} />
                                {/* <!-- Featured image --> */}
                                {/* <PostMedia2 /> */}
                                <MediaType mediaType={post.mediaType} />
                            </div>
                            {/* <!-- /Post body --> */}

                            {/* <!-- Post footer --> */}
                            <div className="card-footer">
                                {/* <!-- Followers avatars --> */}
                                <SocialCount
                                    counts={post.socialCount}
                                    postId={post.id}
                                />
                            </div>
                        </div>
                        {/* <!-- /Post footer --> */}
                        {!showThreads ? (
                            <div className="card-heading">
                                {/* <!-- User meta --> */}
                                <PostUserBlock
                                    user={post.user}
                                    time={post.time}
                                />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    {!showThreads ? (
                        <div className="card-heading">
                            <Link
                                to="/thread"
                                className="cursor-pointer blue-text"
                                // onClick={() => setShowThreads(true)}
                            >
                                Show This Post
                            </Link>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {/* <!-- /Main wrap --> */}
            </div>
            {showThreads ? (
                <>
                    {threads.map((item, i) => (
                        <ThreadSubPost
                            post={item}
                            lastThread={i + 1 === threads.length}
                        />
                    ))}
                    {/* <ThreadSubPost post={posts[3]} />
                    <ThreadSubPost post={posts[4]} lastThread={true} /> */}
                </>
            ) : (
                ""
            )}
        </div>
    );
};

export default ThreadPost;
